import { useEffect, useState } from "react";
import { VerifiedCreatorMark } from "../components/VerifiedCreatorMark";
import { GameButton } from "../components/GameButton";
import { NumgnumCard } from "../components/NumgnumCard";
import { publicApi, type LeaderboardPlayer } from "../lib/supabase";

const fallback: LeaderboardPlayer[] = [
  { rank: 1, username: "THATCHER", wins: 42, draws: 7, losses: 13, battles: 62, win_rate: 67.7, card_count: 96, founder_count: 4 },
  { rank: 2, username: "JOCELYN", wins: 37, draws: 5, losses: 18, battles: 60, win_rate: 61.7, card_count: 88, founder_count: 3 },
  { rank: 3, username: "MELLOWMINNOW42", wins: 21, draws: 9, losses: 12, battles: 42, win_rate: 50, card_count: 54, founder_count: 1 },
];

export function ArenaPage() {
  const [leaders, setLeaders] = useState(fallback);
  useEffect(() => { publicApi.leaderboard().then((rows) => rows.length && setLeaders(rows)).catch(() => undefined); }, []);
  return (
    <div className="arena-page page-scene">
      <div className="scene-heading">
        <p className="eyebrow">The entire rulebook, basically</p>
        <h1 className="arena-manifesto"><span>Painfully simple.</span><em>Unless it’s not.</em></h1>
        <p>Twenty-second rounds. Eleven-card Hoards. Play the higher card, win the match, and one random rival card joins your Hoard. Easy. Allegedly.</p>
      </div>
      <div className="battle-stage">
        <div className="fighter fighter--host"><img src="/art/creatures/chompley.webp" alt="Host fighter" /><strong>HOST</strong></div>
        <NumgnumCard level={3} edition="midnight" className="battle-card battle-card--left" />
        <div className="bite-burst">NOM!</div>
        <NumgnumCard level={2} edition="arcade" className="battle-card battle-card--right" />
        <div className="fighter fighter--rival"><img src="/art/creatures/duobite.webp" alt="Rival fighter" /><strong>RIVAL</strong></div>
      </div>
      <section className="leaderboard-plaque">
        <div><p className="eyebrow">Island leaderboard</p><h2>The hungriest players alive</h2></div>
        <ol>
          {leaders.map((player) => (
            <li key={player.username}><span>#{player.rank}</span><strong>{player.username}<VerifiedCreatorMark username={player.username} /></strong><em>{player.wins} W · {player.draws} D · {player.losses} L</em><b>{player.win_rate}%</b></li>
          ))}
        </ol>
        <GameButton to="/discover" tone="violet">All battle records</GameButton>
      </section>
    </div>
  );
}
